import { createRoot } from 'react-dom/client';
import './css/index.css';
import App from './Home';

createRoot(document.getElementById('root')!).render(<App />)